import { DictionaryService } from "src/app/dictionary/dictionary.service";
import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { ImagePreviewComponent } from "src/app/app/_component/image-preview/image-preview.component";
import { ThisPlatform } from "src/app/_services/platform.service";
import { SpaceService } from "src/app/_services/space.service";

@Component({
  selector: "app-user-assignment-view-details",
  templateUrl: "./user-assignment-view-details.component.html",
  styleUrls: ["./user-assignment-view-details.component.scss"],
})
export class UserAssignmentViewDetailsComponent implements OnInit {
  constructor(
    public modalCtrl: ModalController,
    public p: ThisPlatform,
    public spaceService: SpaceService,
    private dicctionaryServ: DictionaryService
  ) {}

  @Input()
  row;

  @Input()
  type;

  spaceDetails;
  subTypeName: string;
  showModalHeader: boolean = false;

  ngOnInit() {
    if (this.type === "assignment") {
      this.spaceDetails = this.row.space;
    } else if (this.type === "booking") {
      this.spaceDetails = this.row.bookingSpaces[0].space;
    } else if (this.type === "space") {
      this.spaceDetails = this.row;
    }
    this.subTypeName = this.dicctionaryServ.parkingSubtype.find(
      (e) => e.value === this.spaceDetails.subType
    ).key;
  }

  onCloseModal() {
    this.modalCtrl.dismiss();
  }

  async onImagePreview($event, url) {
    $event.stopPropagation();
    $event.preventDefault();

    const modal = await this.modalCtrl.create({
      component: ImagePreviewComponent,
      componentProps: { src: url },
      animated: true,
      cssClass: "image-preview-present",
    });
    modal.present();
  }
}
